export default {
  nav: {
    brand: 'Cemil Kuaför | Hair Design',
    videos: 'Видео',
    gallery: 'Галерея',
    services: 'Услуги',
    contact: 'Контакты',
  },
  hero: {
    title: 'Натуральные микро-накладки в Мармарисе',
    subtitle:
      'Профессиональные процедуры hair design, добавляющие объём, длину и натуральный вид вашим волосам.',
    btnVideos: 'Смотреть видео',
    btnWhatsApp: 'Спросить в WhatsApp',
  },
  videos: {
    title: 'Видео процедур',
    subtitle: 'Откройте для себя наши результаты микро-накладок',
    items: [
      { title: 'Результат микро-накладок', duration: '0:32' },
      { title: 'Натуральный переход', duration: '0:28' },
      { title: 'Объёмная укладка', duration: '0:35' },
      { title: 'До / После', duration: '0:41' },
      { title: 'Ежедневный уход', duration: '0:33' },
      { title: 'Обновление цвета', duration: '0:30' },
      { title: 'Результат кератинового ухода', duration: '0:36' },
      { title: 'Эффект современной перманентной укладки', duration: '0:29' },
      { title: 'Применение омбре', duration: '0:34' },
      { title: 'Блестящая текстура волос', duration: '0:31' },
      { title: 'Стрижка и укладка', duration: '0:37' },
      { title: 'Подготовка свадебной причёски', duration: '0:40' },
      { title: 'Натуральная волнистая модель', duration: '0:27' },
      { title: 'Интенсивное увеличение объёма', duration: '0:38' },
      { title: 'Креативный hair design', duration: '0:42' },
    ],
    playIcon: 'Играть',
    close: 'Закрыть',
    askWhatsApp: 'Спросить в WhatsApp',
  },
  beforeAfter: {
    title: 'До / После',
    subtitle: 'Наши результаты микро-накладок',
    items: [
      { label: 'Невидимые крепления', desc: 'Натуральная и незаметная процедура' },
      { label: 'Идеальное сочетание', desc: 'Полное слияние с вашими волосами' },
      { label: 'Объёмный вид', desc: 'Полный и живой эффект волос' },
      { label: 'Длинные и здоровые волосы', desc: 'Результат профессионального ухода' },
    ],
    contact: 'Связаться',
  },
  why: {
    title: 'Почему микро-накладки?',
    subtitle: 'Преимущества профессионального hair design',
    items: [
      { title: 'Натуральный вид', desc: 'Не отличить от ваших собственных волос' },
      { title: 'Идеальное совпадение', desc: 'Гармония цвета и текстуры' },
      { title: 'Комфортное ношение', desc: 'Лёгкая, не тяжелая система' },
      { title: 'Профессиональная процедура', desc: 'Безопасная работа с многолетним опытом' },
      { title: 'Опытный сервис в Мармарисе', desc: 'Особый уход для местных и иностранных гостей' },
    ],
  },
  services: {
    title: 'Наши услуги',
    subtitle: 'Премиальные процедуры hair design',
    items: [
      {
        title: 'Микро-накладки',
        desc: 'Натуральные, лёгкие и комфортные накладки для волос. Невидимые крепления делают их неотличимыми от ваших волос.',
        badge: 'Популярно',
      },
      {
        title: 'Омбре',
        desc: 'Современные техники градиентного окрашивания. Профессиональное окрашивание, добавляющее глубину и движение вашим волосам.',
      },
      {
        title: 'Перманентная укладка',
        desc: 'Долговременная, уложенная и блестящая укладка волос. Профессиональная процедура, устойчивая к влаге и пухлости.',
      },
    ],
    askPrice: 'Узнать цену и детали',
    viewDetails: 'Подробнее',
  },
  tourist: {
    title: 'Профессиональный hair design в Мармарисе',
    desc: 'Профессиональный парикмахерский и hair design опыт для местных и иностранных гостей в Мармарисе. С многолетним опытом мы предлагаем индивидуальные решения для каждого типа волос.',
    stats: [
      { value: '15+', label: 'Лет опыта' },
      { value: '5000+', label: 'Довольных клиентов' },
      { value: '3', label: 'Языка поддержки' },
    ],
  },
  salon: {
    title: 'Информация о салоне',
    name: 'Cemil Kuaför | Hair Design',
    address: 'Tepe Mah. Над DenizBank',
    city: 'Мармарис / Мугла',
    phone: '0531 345 99 87',
    instagram: '@cemilkuaformarmaris',
    hours: 'Каждый день 09:00 - 20:00',
    getDirections: 'Проложить маршрут',
  },
  whatsapp: {
    cta: 'Спросить в WhatsApp',
    message: 'Здравствуйте, Cemil Kuaför, хотел(а) бы получить информацию о микро-накладках.',
    floatingLabel: 'Напишите нам',
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    subtitle: 'Всё, что нужно знать о микро-накладках, омбре и перманентной укладке',
    items: [
      {
        q: 'Как долго держатся микро-накладки?',
        a: 'При профессиональном нанесении и регулярном уходе микро-накладки служат 3–6 месяцев. Периодическое обслуживание продлевает срок их службы.',
      },
      {
        q: 'Вредят ли микро-накладки моим натуральным волосам?',
        a: 'Нет. При правильном нанесении они не наносят никакого вреда. Они крепятся к средней части волоса, а не к корням.',
      },
      {
        q: 'Можно ли сделать омбре и микро-накладки в один день?',
        a: 'Да, обе процедуры можно совместить в одном сеансе. Таким образом вы получите и цвет, и длину/объём за одно посещение.',
      },
      {
        q: 'Почему цены не указаны на сайте?',
        a: 'Тип волос, плотность и желаемая длина варьируются от человека к человеку, поэтому мы предоставляем индивидуальные расчёты через WhatsApp вместо фиксированных цен.',
      },
      {
        q: 'Можно ли получить услугу во время отпуска в Мармарисе?',
        a: 'Безусловно. Мы обслуживаем всех местных и иностранных гостей с поддержкой на английском и русском языках. Просто запишитесь на приём.',
      },
      {
        q: 'Сколько занимает нанесение микро-накладок?',
        a: 'Обычно 2–4 часа. Плотность волос и желаемая длина могут повлиять на продолжительность.',
      },
      {
        q: 'Как долго держится перманентная укладка?',
        a: 'Перманентная укладка остаётся эффективной в течение 3–6 месяцев, значительно снижая потребность в ежедневном использовании укладочных инструментов.',
      },
      {
        q: 'Как записаться на приём?',
        a: 'Вы можете легко записаться, написав нам через кнопки WhatsApp на странице или позвонив нам напрямую.',
      },
      {
        q: 'Что нужно сделать перед окрашиванием волос?',
        a: 'Достаточно чистых волос. Наша команда экспертов проводит анализ волос перед процедурой, чтобы определить лучшую технику для вас.',
      },
      {
        q: 'Как ухаживать за волосами после микро-накладок?',
        a: 'Мы рекомендуем специальный шампунь и уходовые продукты. Регулярное расчёсывание, использование термозащиты и посещение процедур обслуживания обеспечат долговечный результат.',
      },
    ],
  },
  testimonials: {
    title: 'Отзывы клиентов',
    subtitle: 'Отзывы наших клиентов о микро-накладках',
    items: [
      {
        name: 'Ayşe K.',
        role: 'Мармарис',
        text: 'После нанесения микро-накладок мои волосы выглядят очень натурально. Никто не замечает накладок. Профессионализм господина Джемила действительно на другом уровне.',
        service: 'Микро-накладки',
      },
      {
        name: 'Elena S.',
        role: 'Москва',
        text: 'Приезжала во время отпуска в Мармарисе, результат был великолепен. Наличие поддержки на русском языке было очень обнадёживающе. Определённо рекомендую!',
        service: 'Омбре + Микро-накладки',
      },
      {
        name: 'Jennifer M.',
        role: 'Великобритания',
        text: 'Я была поражена натуральным видом микро-накладок. Джемил и его команда заставили меня чувствовать себя очень желанной. Настоятельно рекомендую для англоговорящих туристов!',
        service: 'Микро-накладки',
      },
      {
        name: 'Büşra T.',
        role: 'Мугла',
        text: 'Сделала перманентную укладку и микро-накладки вместе. Теперь мои волосы готовы каждое утро. Больше никакого ежедневного стресса укладки. Очень довольна.',
        service: 'Перманентная укладка + Микро-накладки',
      },
      {
        name: 'Olga P.',
        role: 'Россия',
        text: 'Прекрасная работа! Волосы выглядят совершенно натурально. Салон очень уютный, персонал профессиональный. Обязательно приду снова в следующем году.',
        service: 'Микро-накладки',
      },
      {
        name: 'Fatma D.',
        role: 'Мармарис',
        text: 'Пользуюсь микро-накладками уже 6 месяцев. Выглядят всё так же, как в первый день. До этого использовала ленточные и кератиновые системы, микро-накладки намного комфортнее и натуральнее.',
        service: 'Микро-накладки',
      },
    ],
    verified: 'Подтверждённый отзыв',
    stars: '5.0',
  },
  footer: {
    copyright: '© 2026 Cemil Kuaför | Hair Design. Все права защищены.',
    followUs: 'Подписывайтесь',
  },
  videoDetails: {
    askMessage: 'Здравствуйте, хотел(а) бы получить информацию и записаться на приём по {{title}}.',
    durationLabel: 'Продолжительность',
    resultLabel: 'Тип результата',
    guaranteeLabel: 'Гарантия',
    detailsTitle: 'Детали процедуры',
    advantagesTitle: 'Преимущества',
    targetAudienceTitle: 'Для кого подходит',
    items: [
      {
        title: 'Микро-накладки',
        subtitle: 'Натуральные, не вредящие волосам премиальные накладки.',
        duration: '2-4 часа',
        resultType: 'Натуральный результат',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'В этом месяце 156 человек записались на микро-накладки',
        socialProofSub: 'Высокий спрос за последние 30 дней',
        description:
          `Естественные переходы, самая изящная форма простоты ✨\nМы коснулись крошечными бликами внутри волос, сдержанный, но выразительный образ 🌿\nС мягкими тонами, которые ловят свет, элегантны с любого ракурса 💫`,
        advantages: [
          'Волосам не применяется химическая обработка',
          'Создаёт натуральный, неотличимый вид',
          'Можно мыть, выпрямлять, красить',
          'Не создаёт ощущения тяжести на коже головы',
          'Можно повторно использовать при профессиональном снятии',
        ],
        targetAudience: [
          'Тонкие волосы, нуждающиеся в объёме',
          'Желающие удлинить волосы',
          'Подходит для использования с платком',
          'Желающие простой ежедневный уход',
        ],
      },
      {
        title: 'Омбре и окрашивание',
        subtitle: 'Премиальные результаты с натуральным градиентом.',
        duration: '1,5-2,5 часа',
        resultType: 'Долговременный результат',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 30 дней омбре сделали 98 человек',
        socialProofSub: 'Любимая цветовая услуга в этом сезоне',
        description:
          `Soft Luxury Волновое Прикосновение ✨\n\nБлеск не кричит… он даёт о себе знать. С волнистыми накладками эта непринуждённая элегантность — именно то, что нужно 💫 Объёмные, динамичные и невероятно естественно выглядящие волны держат ваши волосы готовыми и безупречными в любой момент.\n\nНи чрезмерно, ни тускло… Идеальное ощущение роскоши. Добавляя премиальную нотку даже к повседневным образам, на особых мероприятиях все взгляды прикованы к вам 🖤\n\nИдеальное прикосновение для тех, кто хочет ощущать качество в своих волосах. Потому что настоящая роскошь кроется в деталях ✨`,
        advantages: [
          'Придаёт эффект натурального сияния и глубины',
          'Минимальный вред при окрашивании только кончиков',
          'Долго не выцветает',
          'Ежедневная элегантность без ухода',
          'Лёгкий переход при повторном окрашивании',
        ],
        targetAudience: [
          'Любители современного вида',
          'Ищущие неприхотливый цвет',
          'Желающие долговременный результат',
          'Ищущие тон под свой цвет кожи',
        ],
      },
      {
        title: 'Перманентная укладка и кератиновый уход',
        subtitle: 'Покончите с ежедневной укладкой — гладкие и блестящие волосы.',
        duration: '2-3 часа',
        resultType: 'Эффект 6-8 месяцев',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'К настоящему моменту эту процедуру сделали 2 140 человек',
        socialProofSub: 'Самая востребованная процедура за последние 6 месяцев',
        description:
          `В Cemil Kuaför, одном из первых имён, которые приходят на ум при профессиональных накладках в Мармарисе, наиболее подходящий метод тщательно определяется для ваших волос, и достигается полностью естественный результат.\n\nБлагодаря высококачественным волосам, которые мы используем, и экспертному нанесению, обеспечивается комфортная и долговечная носка. Естественный вид, которым вы можете комфортно пользоваться в повседневной жизни — неотличимый от ваших собственных волос — ждёт вас ✨`,
        advantages: [
          'Сокращает время ежедневной укладки на 90%',
          'Обеспечивает защиту от влажности и дождя',
          'Глубоко питает волосы',
          'Придаёт блеск и гладкость',
          'Выпрямляет без потери натурального движения',
        ],
        targetAudience: [
          'Кудрявые и волнистые волосы',
          'Уставшие от ежедневной укладки феном',
          'Волосы, нуждающиеся в увлажнении',
          'Ищущие ежедневное удобство',
        ],
      },
      {
        title: 'Перманентная укладка нового поколения',
        subtitle: 'Современная перманентная укладка, придающая объём и чёткие волны.',
        duration: '2,5-3,5 часа',
        resultType: 'Долговременный результат',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'К настоящему моменту современную перманентную укладку сделали 1 720 человек',
        socialProofSub: 'Повышенный интерес за последние 24 часа',
        description:
          `Естественность, объём и безупречный переход… ✨\nВ каждом применении мы работаем специально для структуры ваших волос\nПотому что трансформация каждого человека должна быть уникальной 💫\nРезультат? Волосы, которые вновь обретают свой блеск`,
        advantages: [
          'Придаёт объём волосам',
          'Обеспечивает чёткий и эстетичный вид волн',
          'Создаёт более плотный вид волос',
          'Сокращает время ежедневной укладки',
          'Применяется с учётом типа волос',
        ],
        targetAudience: [
          'Тонкие волосы',
          'Желающие волнистый вид',
          'Желающие уложенные волосы',
          'Ищущие ежедневный стиль',
        ],
      },
      {
        title: 'Ежедневный уход за волосами',
        subtitle: 'Практичная ежедневная рутина ухода, поддерживающая здоровье волос.',
        duration: '45-60 мин',
        resultType: 'Мгновенный блеск',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'На этой неделе 73 человека приобрели пакет ежедневного ухода',
        socialProofSub: 'Пользующийся высоким спросом экспресс-уход',
        description:
          `Длинные, полные, безупречные ✨\nВаши волосы — это не просто внешность, это ваша энергия…\nМы воссоздаём эту энергию с нуля 💫\n\nС ультратонкими, невидимыми, полностью естественно выглядящими микро-накладками\nмы добавляем объём, длину и уверенность вашим волосам 🤍\n\nМы здесь для того момента, когда вы посмотрите в зеркало и скажете «как же хорошо»…\nКаждое прикосновение профессионально, каждый результат безупречен ✨\n\nВы мечтаете, мы воплощаем 💌`,
        advantages: [
          'Формула, предотвращающая электризацию',
          'Увлажняет волосы',
          'Быстрое применение',
          'Подходит для ежедневного использования',
          'Сохраняет здоровье волос в долгосрочной перспективе',
        ],
        targetAudience: [
          'Люди с плотным графиком',
          'Ищущие практичный уход',
          'Ценящие здоровье волос',
          'Желающие ежедневный блеск',
        ],
      },
      {
        title: 'Обновление цвета',
        subtitle: 'Быстрая окраска, освежающая текущий цвет и придающая яркие оттенки.',
        duration: '1-1,5 часа',
        resultType: 'Яркий результат',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 14 дней обновление цвета сделали 112 человек',
        socialProofSub: 'Любимая быстрая цветовая услуга',
        description:
          `Совершенно другой вид с одним прикосновением… ✨\n\nМы попрощались с обожжёнными, повреждёнными и безжизненными волосами; и обрели длинные, чёрные и потрясающие волосы. 🤍\nС профессиональными накладками, которые мы нанесли, ваши волосы теперь выглядят намного плотнее, здоровее и ухоженнее.\n\nВолосы — это не просто внешность, это ощущение…\nМы здесь, чтобы помочь вам чувствовать себя сильнее и красивее, когда вы смотрите в зеркало. 🖤`,
        advantages: [
          'Оживляет выцветшие цвета',
          'Придаёт блеск и глубину',
          'Минимальное использование химикатов',
          'Быстрое применение',
          'Не повреждает структуру волос',
        ],
        targetAudience: [
          'Владельцы выцветшего цвета',
          'Ищущие блеск',
          'Желающие быстрый результат',
          'Желающие сохранить текущий цвет',
        ],
      },
      {
        title: 'Интенсивный кератиновый уход',
        subtitle: 'Специальный уход, глубоко восстанавливающий волосы и обеспечивающий долговременную мягкость.',
        duration: '1,5-2 часа',
        resultType: 'Эффект 3-4 месяца',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 30 дней кератиновый уход сделали 215 человек',
        socialProofSub: 'Незаменимый уход зимнего сезона',
        description:
          `Блеск — не случайность… это результат правильных прикосновений. ✨\n\nВолосы — это не просто волосы; это энергия женщины, уверенность и самое сильное отражение её стиля. В этом образе мы находимся прямо посередине между естественностью и роскошью… 🤍\n\nБлагодаря тщательно нанесённой процедуре накладок, волосы приобрели как плотность, так и ожили с этими мягкими, текучими волнами. Каждая прядь была создана с комфортом и лёгкостью, которые ощущаются как ваши собственные волосы. 🌿\n\nЭти кофейные тона, которые ловят свет, подчёркивают черты вашего лица; длинный, объёмный и здоровый вид остаётся с вами весь день, не теряя своего эффекта. Потому что мы не просто делаем волосы… мы оставляем вам ощущение, которое заставляет вас сказать «как же хорошо», когда вы смотрите в зеркало. 💫`,
        advantages: [
          'Восстанавливает секущиеся концы',
          'Уменьшает электризацию',
          'Укрепляет волосы',
          'Обеспечивает долговременную мягкость',
          'Защищает от термической обработки',
        ],
        targetAudience: [
          'Повреждённые волосы',
          'Секущиеся концы',
          'Часто использующие термические инструменты',
          'Ищущие глубокий уход',
        ],
      },
      {
        title: 'Современная перманентная укладка',
        subtitle: 'Современная техника, придающая волосам естественные волны, объём и форму.',
        duration: '2-3 часа',
        resultType: 'Эффект 5-7 месяцев',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 7 дней перманентную укладку сделали 64 человека',
        socialProofSub: 'Трендовый вид с естественными волнами',
        description:
          `Безупречная трансформация с микро-накладками…\nОсобое прикосновение, где длина, объём и естественность встречаются в самом изысканном виде 💫\n\nКаждая прядь тщательно наносится, адаптируясь к структуре ваших волос.\nКрепления невидимы, ощущение лёгкое, а результат предлагает полностью естественную целостность.\n\nБлагодаря профессиональным техникам и высококачественным волосам, которые мы используем, это не просто процедура; достигается персонализированный, долговечный и элегантный вид ✨\nИзменение, далёкое от преувеличения, но ощущаемое с первого взгляда…\n\nС микро-накладками мы создаём простую, но мощную разницу в ваших волосах.\nПотому что настоящая роскошь — это самая совершенная форма естественности 🤍`,
        advantages: [
          'Придаёт естественный волнистый вид',
          'Добавляет объём волосам',
          'Облегчает ежедневную укладку',
          'Долговременный результат',
          'Подбирается под тип волос',
        ],
        targetAudience: [
          'Желающие естественные волны',
          'Прямые и тонкие волосы',
          'Ищущие ежедневное удобство',
          'Любители современного вида',
        ],
      },
      {
        title: 'Омбре и балаяж',
        subtitle: 'Элегантные цветовые переходы на кончиках волос с эффектом естественного сияния.',
        duration: '2-3 часа',
        resultType: 'Долговременный результат',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 60 дней омбре/балаяж сделали 178 человек',
        socialProofSub: 'Любимая цветовая техника во все сезоны',
        description:
          `💁‍♀️ Мы добавляем дополнительный объём, движение и уникальный стиль вашим волосам с микро-накладками, которые обеспечивают естественный и безупречный переход.\n🌿 Мы выбираем тона специально для структуры ваших волос; более живой, блестящий и ухоженный вид гарантирован!\n💫 Легко укладываемые, естественные, но привлекающие внимание объёмные волосы для повседневного использования.\n🔥 Микро-накладки, выполненные профессиональными техниками, добавляют долговечную форму и энергию вашим волосам.`,
        advantages: [
          'Обеспечивает естественный цветовой переход',
          'Корни защищены за счёт окрашивания кончиков',
          'Долго не требует ухода',
          'Подбор тона под цвет кожи',
          'Современный и элегантный вид',
        ],
        targetAudience: [
          'Ищущие естественное сияние',
          'Не желающие красить корни',
          'Любители современного вида',
          'Желающие долговременный цвет',
        ],
      },
      {
        title: 'Уход за блеском волос',
        subtitle: 'Специальный уход с сыворотками для мгновенного блеска и жизненной силы волос.',
        duration: '30-45 мин',
        resultType: 'Мгновенный блеск',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'В среднем 25 человек ежедневно делают уход за блеском',
        socialProofSub: 'Высоко востребован за быстрый и эффективный результат',
        description:
          `Блеск — не случайность, это результат правильного прикосновения…\nДля глубины, сияния и безупречных переходов в волосах наиболее точная техника — профессиональное нанесение накладок 💫\nКаждая прядь была размещена с заботой, стремясь к естественному виду и максимальному комфорту.\nРезультат? Более плотный, объёмный и по-настоящему безупречный вид 🤍`,
        advantages: [
          'Придаёт мгновенный блеск',
          'Увеличивает жизненную силу волос',
          'Очень быстрое применение',
          'Идеально для особых случаев',
          'Не повреждает структуру волос',
        ],
        targetAudience: [
          'Ищущие быстрый результат',
          'Подготовка к особым мероприятиям',
          'Тусклые и безжизненные волосы',
          'Желающие мгновенный блеск',
        ],
      },
      {
        title: 'Профессиональная стрижка и укладка',
        subtitle: 'Современная и персонализированная стрижка и укладка, подходящая чертам лица.',
        duration: '45-75 мин',
        resultType: 'Устойчивая форма',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'В этом месяце услугу стрижки и укладки получили 340 человек',
        socialProofSub: 'Всегда популярная базовая услуга',
        description:
          `Самая совершенная форма естественности ✨\nС микро-накладками объём, длина и шелковистый блеск объединяются в ваших волосах…\nНастолько естественное, лёгкое и комфортное использование, что неотличимо от ваших собственных волос 🤍`,
        advantages: [
          'Модель под черты лица',
          'Техника под тип волос',
          'Облегчает ежедневный уход',
          'Современный и трендовый вид',
          'Профессиональная укладка включена',
        ],
        targetAudience: [
          'Ищущие новую модель',
          'Желающие стрижку под черты лица',
          'Любители современного вида',
          'Ищущие ежедневную практичность',
        ],
      },
      {
        title: 'Свадебная причёска и макияж',
        subtitle: 'Специальный дизайн, пробная укладка и нанесение причёски вашей мечты.',
        duration: '2-4 часа',
        resultType: 'Сохраняется весь день',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'В этом сезоне мы создали 89 свадебных причёсок',
        socialProofSub: 'Самый востребованный пакет свадебного сезона',
        description:
          `💁‍♀️ С мелированием мы добавляем естественные и мягкие переходы блеска вашим волосам.\n🌿 С тонами, подходящими для структуры ваших волос, более живой, блестящий и ухоженный вид.\n💫 Легко укладываемые, объёмные и привлекающие внимание волосы для повседневного использования.\n✨ Профессиональные применения, которые долго сохраняют свою форму.`,
        advantages: [
          'Пробная укладка до свадьбы',
          'Дизайн в гармонии с платьем',
          'Укладка, сохраняющаяся весь день',
          'Использование специальных аксессуаров',
          'Подходит для фото- и видеосъёмки',
        ],
        targetAudience: [
          'Будущие невесты',
          'Подготовка к помолвке и особым дням',
          'Желающие стойкую укладку',
          'Ищущие профессиональный вид',
        ],
      },
      {
        title: 'Натуральная волнистая модель',
        subtitle: 'Волнистая укладка, подчёркивающая естественную текстуру волос без использования нагрева.',
        duration: '45-60 мин',
        resultType: 'Сохраняется весь день',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 30 дней 56 человек выбрали эту модель',
        socialProofSub: 'Любимица тренда естественной красоты',
        description:
          `Дайте вашим волосам заслуженный уход… 🌿\nВ Cemil Kuaför процедуры накладок применяются с персонализированным анализом, стремясь к самому естественному результату. 💇‍♀️✨\n\nВновь откройте для себя свою уверенность с блестящими, плотными и безупречно выглядящими волосами. 💫`,
        advantages: [
          'Укладка без нагрева',
          'Сохраняет здоровье волос',
          'Придаёт естественный волнистый вид',
          'Сохраняется весь день',
          'Можно делать ежедневно',
        ],
        targetAudience: [
          'Любители естественного вида',
          'Избегающие термической обработки',
          'Ценящие здоровье волос',
          'Желающие мягкие волны',
        ],
      },
      {
        title: 'Интенсивное увеличение объёма',
        subtitle: 'Специальная стрижка и укладка, придающие тонким волосам плотность и объём.',
        duration: '1-1,5 часа',
        resultType: 'Мгновенный объём',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 30 дней 134 человека сделали увеличение объёма',
        socialProofSub: 'Спасение для тонких волос',
        description:
          `Длинные и плотные волосы вашей мечты теперь возможны ✨\nВ Cemil Kuaför мы даём вашим волосам новую жизнь с профессиональными процедурами накладок 💇‍♀️💖\nВновь откройте для себя естественный вид, идеальную гармонию и долговечные результаты.`,
        advantages: [
          'Придаёт мгновенную плотность',
          'Поднимает волосы у корней',
          'Поддерживается специальными объёмными средствами',
          'Облегчает ежедневную укладку',
          'Долговременный эффективный результат',
        ],
        targetAudience: [
          'Тонкие волосы',
          'Испытывающие нехватку объёма',
          'Желающие плотный вид',
          'Ищущие поднятость у корней',
        ],
      },
      {
        title: 'Креативный hair design',
        subtitle: 'Уникальные и художественные дизайны волос, отражающие вашу индивидуальность.',
        duration: '1,5-3 часа',
        resultType: 'Уникальный дизайн',
        guarantee: 'Гарантия удовлетворения',
        socialProof: 'За последние 90 дней 47 человек сделали креативный дизайн',
        socialProofSub: 'Выбор тех, кто ищет оригинальный стиль',
        description:
          `В Cemil Kuaför процедуры накладок тщательно планируются не только для удлинения, но и для достижения наиболее естественной гармонии, подходящей для структуры ваших волос, тона кожи и стиля. 💇‍♀️💫`,
        advantages: [
          'Полностью персонализированный дизайн',
          'Комбинация цвета и стрижки',
          'Оригинальный и художественный результат',
          'Включена профессиональная консультация',
          'Трендовые и современные техники',
        ],
        targetAudience: [
          'Ищущие оригинальный стиль',
          'Любители художественного вида',
          'Предпочитающие цветные волосы',
          'Желающие уникальный дизайн',
        ],
      },
    ],
  },
};